import { FlexDiv } from 'components/generic/HomePageComponents'
import { CenteredDiv, MainDiv, Header } from './Footer.styles'
import ColouredTextItems, { ColouredTextItemsProps } from './ColouredTextItems'
import Cities, { CitiesProps } from './Cities'

export type CareguideFamilyProps = {
  header: string
  siteName: string
  colouredTextItems: ColouredTextItemsProps['colouredTextItems']
  cities: CitiesProps['cities']
}

const CareguideFamily = ({ header, colouredTextItems, cities, siteName }: CareguideFamilyProps) => {
  return (
    <MainDiv role='region' aria-label={`${siteName} ${header}`}>
      <CenteredDiv role='list'>
        <Header ml='10px' mr='10px' aria-hidden>
          {siteName} {header}
        </Header>
        <FlexDiv flexWrap='wrap' justifyContent='center' mb='20px'>
          <ColouredTextItems colouredTextItems={colouredTextItems} domain={siteName} />
        </FlexDiv>
        <FlexDiv flexWrap='wrap' alignSelf='center' maxWidth='950px' flexDirection='row'>
          <Cities cities={cities} domain={siteName} />
        </FlexDiv>
      </CenteredDiv>
    </MainDiv>
  )
}

export default CareguideFamily
